import { render, staticRenderFns } from "./aws.vue?vue&type=template&id=3c201a50&"
import script from "./aws.vue?vue&type=script&lang=js&"
export * from "./aws.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports